export const emailCredentials = {
  USER_ID: `service_7bmfo0n`, //userID
  TEMPLATE_ID: `template_b2576fx`, //templateID
};
